import {createAsyncThunk} from '@reduxjs/toolkit'
import {UserInterface} from '@/types/types'
import {SET_WALLET} from '@/store/slices/wallet'

export const setWallet = createAsyncThunk(
  'index/setWallet',
  async (profile: UserInterface, {dispatch}) => {
    dispatch(
      SET_WALLET({
        octa: profile.octa,
        hexa: profile.hexa,
        reex: profile.reex,
        hepta: profile.hepta,
        ethos: profile.ethos,
        terra: profile.terra || 0,
        dominion: profile.dominion || 0,
        loyalty: profile.loyalty || 0,
        onegm: profile.onegm || 0,
      })
    )
  }
)
